import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductList.css";
import { db } from "../firebase"; // <-- ton fichier firebase.js
import { collection, getDocs, limit, orderBy, query, startAfter, where } from "firebase/firestore";
import { useCart } from "../CartProvider";
import { MdInfoOutline } from "react-icons/md";
import { FaWhatsapp} from "react-icons/fa";

import ModalDetail from "./ModalDetail";
/**
 * Map de colonnes Firestore -> format UI attendu
 * Adapte les valeurs à tes champs:
 *  - exemple: titleField: "name" si dans Firestore c'est "name"
 */
const COLUMN_MAP = {
  idField: "id",              // si tes docs ont un champ id custom; sinon on utilisera doc.id
  titleField: "Name",
  categoryField: "category",
  imageField: "ImageUrl",        // URL vers image principale
  priceField: "Stores",
  oldPriceField: "oldPrice",
  stockField: "QuantityAvailable",
  // facultatif: un booléen/flag dans Firestore pour afficher "Sale!"
  saleField: "onSale",
};

/** Transforme un doc Firestore → objet produit normalisé pour l'UI */
function normalizeProduct(doc, map) {
  const d = doc.data ? doc.data() : doc; // robuste si on passe déjà un objet
  const id = d?.[map.idField] ?? doc.id; // priorité au champ, sinon doc.id
  return {
    id,
    title: d?.[map.titleField] ?? "Untitled",
    category: (d?.[map.categoryField] ?? "").toString(),
    image: d?.[map.imageField] ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.[map.oldPriceField] ?? 0),
    stock: Number(
    Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
    Number(d?.Stores?.Dekon?.Quantity ?? 0) +
    Number(d?.Stores?.Baguida?.Quantity ?? 0)
  ) ,
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    onSale: Boolean(d?.[map.saleField] ?? false),
    IsPack: Boolean(d?.HasChilds ?? false),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    ParentId: (d?.ParentId == null || String(d.ParentId).trim() === '') ? doc.id : d.ParentId , 
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}



export default function ProductList({getType}) {
  const { cart, addToCart, inc, dec } = useCart();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [myData , setMyData] = useState([]);
  
  // ------- state produits (depuis Firestore) -------
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  // ------- cart local par id -------

  // Charger des produits en stock depuis Firestore (par pages successives jusqu'à atteindre TARGET)
  useEffect(() => {
    let mounted = true;

    async function fetchProducts(cat) {
      try {
        setLoading(true);
        setErr("");

        const TARGET = 48;     // nombre de produits en stock qu'on veut afficher
        const PAGE_SIZE = 48;  // taille de chaque page lue dans Firestore
        const MAX_PAGES = 5;   // garde-fou: max 5 pages (240 docs) pour limiter les coûts de lecture

        let collected = [];
        let lastDoc = null;
        let page = 0;

        while (collected.length < TARGET && page < MAX_PAGES) {
          const constraints = [collection(db, "items")];

          if (cat != null) {
            constraints.push(where("Categorie.Id", "==", cat.id));
          }
          constraints.push(where("IsProductValidated", "==", true));
          constraints.push(orderBy("__name__")); // nécessaire pour startAfter
          if (lastDoc) {
            constraints.push(startAfter(lastDoc));
          }
          constraints.push(limit(PAGE_SIZE));

          const q = query(...constraints);
          const snap = await getDocs(q);

          if (snap.empty) break; // plus aucun document à lire

          const pageProducts = snap.docs
            .map((doc) => normalizeProduct(doc, COLUMN_MAP))
            .filter((p) => p.stock > 0); // ne garder que les produits en stock

          collected = collected.concat(pageProducts);
          lastDoc = snap.docs[snap.docs.length - 1];
          page += 1;

          if (snap.docs.length < PAGE_SIZE) break; // dernière page Firestore atteinte
        }

        if (!mounted) return;
        setProducts(collected.slice(0, TARGET));
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les produits.");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchProducts(getType);
    return () => {
      mounted = false;
    };
  }, [getType]);

  const content = useMemo(() => {
    if (loading) {
      // squelette simple
      return (
        <div className="grid-pl">
          {Array.from({ length: 8 }).map((_, i) => (
            <article key={i} className="card-pl" aria-busy="true">
              <div className="card-media-pl" style={{ background: "#f3f4f6" }} />
              <div className="card-body-pl">
                <p className="category-pl" style={{ background: "#f3f4f6", height: 12, width: "60%" }} />
                <p className="title-pl" style={{ background: "#f3f4f6", height: 16, width: "80%" }} />
                <div className="price-row-pl" style={{ background: "#f3f4f6", height: 14, width: "50%" }} />
                <button className="add-btn-pl" disabled>Loading…</button>
              </div>
            </article>
          ))}
        </div>
      );
    }
    if (err) {
      return <p style={{ color: "#b91c1c" }}>{err}</p>;
    }
    if (!products.length) {
      return <p>Aucun produit disponible.</p>;
    }

    const handleDetails = (item) => {
    navigate(`/details/${item.id}`, { state: { item } });
  };

    return (
      <>
      <div className="grid-pl">
        {products.map((p, idx) => {
          const qty = cart[p.id]?.qty ?? 0;
          const inCart = qty > 0;

          return (
            <article key={p.id} className="card-pl">
              <div className="card-media-pl">
                {/* image fallback si vide */}
                <img
                  src={p.image || "https://via.placeholder.com/800x600?text=No+image"}
                  alt={p.title}
                  loading="lazy"
                  onClick={() => handleDetails(p)}
                />
               <button 
               className="wish-pl" 
               aria-label="Plus de détails" 
               onClick={(e) => {
                  e.stopPropagation(); // empêche le clic de remonter jusqu'à l'image
                  setMyData(p);
                  setIsOpen(true);
                }}
               >
                  <MdInfoOutline size={14} aria-hidden="true" />
                </button>

                
                {p.IsPack  && (
                  <span className="badge-pl">Paquet</span>
                )}
              </div>

              <div className="card-body-pl">
                <p className="category-pl">{(p.category || "").toUpperCase()}</p>

                <p className="title-pl" title={p.title}>
                  {p.title}
                </p>

                {/* rating + reviews (fixe pour la maquette) */}
                <div className="rating-row-pl">
                </div>

                {/* prix */}
                <div className="price-row-pl">
                  <span className="price-pl">
                    {p.price} FCFA
                  </span>
                  {!!p.oldPrice && (
                    <span className="old-price-pl">
                      {p.oldPrice} FCFA
                    </span>
                  )}
                </div>

                {/* CTA zone */}
                {!inCart ? (
                  p.stock > 0
                  ?
                  <button className="add-btn-pl" onClick={() => addToCart(p.id , p)}>
                    <span className="cart-ico-pl" aria-hidden="true">+</span>
                    Add to Cart
                  </button>
                  :
                  <button className="add-btn-pl" onClick={() => { setMyData(p); setIsOpen(true)}}>
                    <span  aria-hidden="true"><FaWhatsapp size={20} /></span>
                    Reserver
                  </button>
                ) : (
                  <>
                    <div className="qty-wrap-pl">
                      <span className="qty-label-pl">Quantity</span>
                      <div className="qty-ctrl-pl">
                        <button onClick={() => dec(p.id)} aria-label="Decrease">−</button>
                        <span style={{ margin: "0 8px" }}>{qty}</span>
                        <button 
                        onClick={() => inc(p.id, p.stock)} 
                        aria-label="Increase"
                        >+</button>
                      </div>
                    </div>

                    <div className="subtotal-pl">
                      <span>{window.innerWidth >= 600 ? "Sous total" : "Total"}</span>
                      <strong>
                        {(qty * p.price)} FCFA
                      </strong>
                    </div>
                  </>
                )}
              </div>
            </article>
          );
        })}
      </div>
      
      
      </>
    );
  }, [products, cart, loading, err]);

  return (
    <>
    <section className="product-list-pl">
      {content}
      
      <div className="all-pager-all">
              <button
                className="all-loadmore-all"
                onClick={() => navigate('/products')}
              >
                Afficher Plus
              </button>
            </div>
    </section>
    <ModalDetail isOpen={isOpen} onClose={() => setIsOpen(false)} myProducts={myData}/>
    </>
  );
}